import { render, staticRenderFns } from "./EmailVerifications.vue?vue&type=template&id=7fed5959&"
import script from "./EmailVerifications.vue?vue&type=script&lang=js&"
export * from "./EmailVerifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports